import {
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";

const { mobileFirstCss } = mediaQueryStyles;
const { textMObj } = typographyStyles;
const { colors } = constants;

export const pollEditOptionsCss = {
  display: "flex",
  justifyContent: "center",
  padding: "12px 0",
};

export const trashButtonCss = {
  margin: "-5px 0 0 8px",
};

export const trashButtonIconCss = {
  path: {
    stroke: colors.ui.neutral[400],
    strokeWidth: "3px",
  },
};

export const questionPlaceholderCss = {
  "&::placeholder": {
    color: colors.ui.neutral[300],
    ...textMObj,
    margin: 0,
  },
};

export const pollFormCss = mobileFirstCss({
  backgroundColor: constants.colors.ui.white[700],
  maxWidth: "905px",
  margin: "auto",
  padding: ["16px", "12px 24px"],
});

export const responseFieldWrapperCss = {
  display: "flex",
  alignItems: "center",
};
